import BN from 'bn.js'
import Web3 from 'web3'

export function fromWei(wei, decimals) {
  if (!wei) {
    return '0'
  }
  const num = new BN(wei, 10).mul(new BN(10).pow(new BN(18 - decimals)))
  return Web3.utils.fromWei(num, 'ether')
}

export function toWei(n, decimals) {
  if (!n) {
    return new BN(0)
  }
  const wei = new BN(Web3.utils.toWei(String(n), 'ether'), 10)
  return wei.div(new BN(10).pow(new BN(18 - decimals)))
}

export function showFromWei(wei, decimals, dots) {
  let num = fromWei(wei, decimals)
  const index = num.indexOf('.')
  if (index !== -1) {
    num = num.substring(0, dots + index + 1)
  }
  if (num.endsWith('.')) {
    num = num.substring(0, num.length - 1)
  }
  return num
}

export function showAccount(account) {
  if (!account) {
    return ''
  }
  return `${account.substring(0, 4)}...${account.substring(account.length - 4)}`
}

export function showLongAccount(account) {
  if (!account) {
    return ''
  }
  return `${account.substring(0, 8)}...${account.substring(account.length - 8)}`
}

export function showLongLongAccount(account) {
  if (!account) {
    return ''
  }
  return `${account.substring(0, 15)}...${account.substring(account.length - 13)}`
}

export function saveRef() {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  if (ref && window.localStorage) {
    window.localStorage.ref = ref.replace('/', '')
  }
  return ref
}

export function getRef() {
  const params = new URLSearchParams(window.location.search)
  const ref = params.get('ref')
  if (ref) {
    return ref.replace('/', '')
  }
  if (window.localStorage) {
    return window.localStorage.ref || null
  }
  return null
}
